const Visa = (props) => (
  <svg {...props} viewBox="0 0 48 36" aria-hidden="true" focusable="false">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <rect fill="#FFFFFF" x="7" y="13" width="34" height="12" />
        <g transform="translate(7.000000, 13.000000)" fillRule="nonzero">
          <polygon
            fill="#1A1F71"
            points="14.460907 11 12 11 13.5392276 0 16 0"
          />
          <path
            d="M25,0.453339721 C24.4739682,0.237886668 23.6396383,0 22.6079918,0 C19.9743328,0 18.1197317,1.44990419 18.1083564,3.52283055 C18.086481,5.05223104 19.4361966,5.90169724 20.445676,6.41164796 C21.4774683,6.93274021 21.8282048,7.27285792 21.8282048,7.73733917 C21.8177045,8.45069806 20.9944582,8.77952368 20.2266297,8.77952368 C19.1618784,8.77952368 18.5913665,8.60999179 17.7243693,8.21311251 L17.3731953,8.04297837 L17,10.4332877 C17.6254922,10.7274843 18.7778912,10.9885574 19.9743328,11 C22.7726411,11 24.5944291,9.57252943 24.6160128,7.36349576 C24.6266589,6.15132768 23.9139565,5.22251574 22.3774245,4.46353682 C21.4446551,3.97632083 20.873414,3.64779633 20.873414,3.14928826 C20.8843518,2.6960991 21.3565699,2.23191897 22.4095085,2.23191897 C23.2765058,2.20918423 23.913519,2.42433616 24.3960916,2.63963865 L24.6373049,2.7527101 L25,0.453339721 L25,0.453339721 L25,0.453339721 Z"
            fill="#1A1F71"
          />
          <path
            d="M28.3117085,7.10319132 C28.5412152,6.47124698 29.4243436,4.02543727 29.4243436,4.02543727 C29.4127615,4.04892326 29.6533931,3.38182769 29.7910057,2.97230038 L29.9857663,3.92013913 C29.9857663,3.92013913 30.5135098,6.55321465 30.6281108,7.10319132 C30.1925662,7.10319132 28.8621588,7.10319132 28.3117085,7.10319132 L28.3117085,7.10319132 Z M31.7517183,0 L29.5960926,0 C28.9313461,0 28.4263095,0.198775504 28.1395023,0.912687527 L24,11 L26.9241531,11 C26.9241531,11 27.4055685,9.64232287 27.5090446,9.34991445 C27.8298359,9.34991445 30.6744388,9.34991445 31.0871242,9.34991445 C31.1671315,9.73611131 31.4196498,11 31.4196498,11 L34,11 L31.7517183,0 L31.7517183,0 L31.7517183,0 Z"
            fill="#1A1F71"
          />
          <path
            d="M10.0013646,0 L7.22417269,7.50891025 L6.92069597,5.98601537 C6.40725119,4.22879305 4.79697919,2.3196082 3,1.37030956 L5.54380796,11 L8.54259839,11 L13,0 L10.0013646,0 L10.0013646,0 L10.0013646,0 Z"
            fill="#1A1F71"
          />
          <path
            d="M4.68648076,0 L0.0474592306,0 L0,0.222996697 C3.61872691,1.13885927 6.01533922,3.34651096 7,6 L5.99153077,0.927722438 C5.8255023,0.222840646 5.31527615,0.02325158 4.68648076,0 L4.68648076,0 Z"
            fill="#F7B700"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Visa;
